module.exports = __webpack_public_path__ + "static/media/Паспорт Базовая станция.edba422a.pdf";